import { FileText } from 'lucide-react';

export function BasicInfo() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Informacje ogólne
        </h2>
      </div>
      
      <div className="space-y-4">
        <p className="body-medium">
          Strona internetowa <strong>znajdki.pl</strong> jest częściowo zgodna z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych z powodu niezgodności lub wyłączeń wymienionych poniżej.
        </p>
        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h3 className="heading-5 mb-4">
            Daty publikacji i aktualizacji
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h4 className="label-large mb-1">
                Data publikacji strony
              </h4>
              <p className="body-medium no-margin">
                27 wrzesień 2025
              </p>
            </div>
            <div>
              <h4 className="label-large mb-1">
                Data ostatniej aktualizacji
              </h4>
              <p className="body-medium no-margin">
                07 listopada 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}